<template>
    <div class="content-wrapper">

        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.setting.changePassword')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <form role="form" @submit.prevent="submit()">
                    <div class="card">
                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.setting.changePassword')}}</div>
                            <b-button type="submit" variant="primary" class="float-right">{{$t('button.update')}}</b-button>
                        </div>

                        <div class="card-body">

                            <div class="form-group">
                                <label for="currentPassword">{{$t('form.setting.currentPassword')}}<span class="text-danger">*</span></label>
                                <input type="text" id="currentPassword" class="form-control"
                                    :class="{ 'is-invalid': $v.password.currentPassword.$error }"
                                    v-model.trim="$v.password.currentPassword.$model">
                                <div class="invalid-feedback" v-if="!$v.password.currentPassword.required">
                                    {{$t('form.validation.required')}}
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="newPassword">{{$t('form.setting.newPassword')}}<span class="text-danger">*</span></label>
                                <input type="password" id="newPassword" class="form-control"
                                    :class="{ 'is-invalid': $v.password.newPassword.$error }"
                                    v-model.trim="$v.password.newPassword.$model">
                                <div class="invalid-feedback" v-if="!$v.password.newPassword.required">
                                    {{$t('form.validation.required')}}
                                </div>
                                <div class="d-flex justify-content-start mt-3">
                                    <div class="ml-0"><span><i class="fas fa-times text-muted" v-if="!$v.password.newPassword.minLength || !$v.password.newPassword.required"></i><i class="fas fa-check text-success" v-else-if="$v.password.newPassword.minLength && $v.password.newPassword.required"></i><span class="ml-2">{{$t('form.validation.atleast8characters')}}</span></span></div>
                                    <div class="ml-5"><span><i class="fas fa-times text-muted" v-if="!$v.password.newPassword.containsUppercase"></i><i class="fas fa-check text-success" v-else-if="$v.password.newPassword.containsUppercase"></i><span class="ml-2">{{$t('form.validation.uppercase')}}</span></span></div>
                                    <div class="ml-5"><span><i class="fas fa-times text-muted" v-if="!$v.password.newPassword.containsLowercase"></i><i class="fas fa-check text-success" v-else-if="$v.password.newPassword.containsLowercase"></i><span class="ml-2">{{$t('form.validation.lowercase')}}</span></span></div>
                                    <div class="ml-5"><span><i class="fas fa-times text-muted" v-if="!$v.password.newPassword.containsNumber"></i><i class="fas fa-check text-success" v-else-if="$v.password.newPassword.containsNumber"></i><span class="ml-2">{{$t('form.validation.numbers')}}</span></span></div>
                                    <div class="ml-5"><span><i class="fas fa-times text-muted" v-if="!$v.password.newPassword.containsSpecial"></i><i class="fas fa-check text-success" v-else-if="$v.password.newPassword.containsSpecial"></i><span class="ml-2">{{$t('form.validation.symbols')}}</span></span></div>
                                </div>
                             </div>
                            <div class="form-group">
                                <label for="confirmPassword">{{$t('form.setting.confirmPassword')}}<span class="text-danger">*</span></label>
                                <input type="password" id="confirmPassword" class="form-control"
                                    :class="{ 'is-invalid': $v.password.confirmPassword.$error }"
                                    v-model.trim="$v.password.confirmPassword.$model">
                                <div class="invalid-feedback" v-if="!$v.password.confirmPassword.required">
                                    {{$t('form.validation.required')}}
                                </div>
                                <div class="invalid-feedback" v-if="!$v.password.confirmPassword.sameAsPassword">
                                    {{$t('form.validation.sameAsPassword')}}
                                </div>
                                <div class="invalid-feedback" v-if="!$v.password.confirmPassword.minLength">
                                    {{$t('form.validation.minLength', {num: $v.password.confirmPassword.$params.minLength.min})}} -->
                                 </div>
                          </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
   import {
        required,
        sameAs,
        minLength,
        maxLength,
        alpha,
        between
    } from "vuelidate/lib/validators";
    export default {
        props: ['permissions'],

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                password: {
                    currentPassword: '',
                    newPassword: '',
                    confirmPassword: '',
                }
            }
        },
        validations: {

            password: {
                currentPassword: {
                    required
                },
                newPassword: {
                    required,
                    minLength:minLength(8),
                    containsUppercase: function(value) {
                    return /[A-Z]/.test(value)
                    },
                    containsLowercase: function(value) {
                    return /[a-z]/.test(value)
                    },
                    containsNumber: function(value) {
                    return /[0-9]/.test(value)
                    },
                    containsSpecial: function(value) {
                    return /[#?!@$%^&*-]/.test(value)
                    }
                },
                confirmPassword: {
                    required,
                    minLength:minLength(8),
                    sameAsPassword:sameAs('newPassword')
                }
            },
        },

        mounted() {

        },

        methods: {

           submit() {

                this.$v.$touch();

                if (this.$v.$invalid) {
                    this.showAlert(this.$t('form.validation.error'), 'danger');
                    return;
                }

                this.clearAlert();
                this.isLoading = true;
                axios
                    .post('/api/user/change-password', this.password)
                    .then(response => {
                            this.isLoading = false;

                        if (response.data.success) {
                                this.showAlert(response.data.message, 'success');

                            }

                    }).catch(error => {
                        this.isLoading = false;
                        if(error.response.data.errors){
                        const objectArray = Object.entries(error.response.data.errors);
                        var index=1;
                        objectArray.forEach(([key, value]) => {
                        for(var j=0;j<error.response.data.errors[key].length;j++){
                            this.showAlert(error.response.data.errors[key][0], 'danger');
                            }
                          });
                        }
                        else
                        {
                            this.showAlert(error.response.data.message,'danger');
                        }
                    })
                },

            showAlert(message, cls = 'success') {
                this.alertMessage = message;
                this.alertClass = cls;
                this.alert = true;
            },

            clearAlert() {
                this.alert = false;
                this.alertClass = '';
                this.alertMessage = '';
            }
        }
    }

</script>
